// index.js is the entry point for the React application. It initializes providers, routing, and renders the root component.

import React from "react"; // Importing React library
import ReactDOM from "react-dom/client"; // Importing ReactDOM for rendering
import { createBrowserRouter, RouterProvider } from "react-router-dom"; // Import new data router APIs
import App from "./App"; // Importing main App component
import "./index.css"; // Importing CSS for this file
import { ApolloProvider } from '@apollo/client/react'; // Added ApolloProvider import
import { client } from './features/core/apollo/client'; // Added Apollo Client instance import
import { PrivacyConsentProvider } from "features/privacy/PrivacyConsentContext";

// Create React root and render application wrapped in necessary providers
const container = document.getElementById("root"); // Getting the root element from the DOM
if (!container) throw new Error("Root container missing in index.html"); // Throwing error if root is not found

const root = ReactDOM.createRoot(container); // Creating a root for ReactDOM

// Define the router using the new data router API
const router = createBrowserRouter([
  {
    path: "/*",
    element: <App />,
  },
]);

const AppWithProviders = () => {
  return (
    <PrivacyConsentProvider>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </PrivacyConsentProvider>
  );
};

root.render( // Rendering the root
  <React.StrictMode>
    <ApolloProvider client={client}> {/* Wrap with ApolloProvider to provide Apollo Client context */}
      <AppWithProviders />
    </ApolloProvider>
  </React.StrictMode>
);
